import { useEffect, type RefObject } from 'react';
import styled from 'styled-components';

type ClickOutsideHandler = (event: MouseEvent | TouchEvent) => void;

export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  handler: ClickOutsideHandler,
): void => {
  useEffect(() => {
    let startedInside = false;
    let startedWhenMounted = false;

    const listener = (event: MouseEvent | TouchEvent) => {
      if (startedInside || !startedWhenMounted) return;
      if (!ref.current || ref.current.contains(event.target as Node)) return;

      handler(event);
    };

    const validateEventStart = (event: MouseEvent | TouchEvent) => {
      startedWhenMounted = Boolean(ref.current);
      startedInside = Boolean(ref.current && ref.current.contains(event.target as Node));
    };

    document.addEventListener('mousedown', validateEventStart);
    document.addEventListener('touchstart', validateEventStart);
    document.addEventListener('click', listener);

    return () => {
      document.removeEventListener('mousedown', validateEventStart);
      document.removeEventListener('touchstart', validateEventStart);
      document.removeEventListener('click', listener);
    };
  }, [ref, handler]);
};

interface IColorSwatchProps {
  backgroundColor: string;
}

export const ColorSwatch = styled.div<IColorSwatchProps>`
  background: ${({ backgroundColor }) => backgroundColor};
  width: 37px;
  height: 37px;
  border-radius: 8px;
  border: 4px solid #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;

export const Picker = styled.div`
  position: relative;
`;

export const Popover = styled.div`
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  border-radius: 9px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  z-index: 20;
`;
